const translations = {
  cta: "Explore media",
  heading: "Picked for you"
};

export default translations;
